
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/account/privacy-settings",
      function () {
        return require("private-next-pages/qmee/account/privacy-settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/account/privacy-settings"])
      });
    }
  